<template>
  <div :class="['keyboard', keyboardClass]">
    <div
      v-for="(row, rowIndex) in displayedLayout[layout]"
      :key="`row-${rowIndex}`"
      class="row"
    >
      <div
        v-for="key in row"
        :key="key.label"
        :class="['item', key.classes || '']"
        @click.stop="handleClick(key)"
      >
        <keyboard-icons-component :label="key.label" />
      </div>
    </div>
  </div>
</template>

<script>
import KeyboardIconsComponent from "./KeyboardIconsComponent.vue";

export default {
  name: "BaseKeyboardComponent",
  components: {
    KeyboardIconsComponent,
  },
  props: {
    keyLayout: {
      type: Object,
      required: true,
    },
    keyboardClass: {
      type: String,
      default: "",
    },
  },
  emits: ["addToInput", "removeLastChar", "submit"],
  data() {
    return {
      layout: "letters",
      isShifted: false,
      isCaps: false,
    };
  },
  computed: {
    displayedLayout() {
      const newLetters = this.keyLayout.letters.map((row) =>
        row.map((key) => ({
          ...key,
          label:
            (key.action === "shift" || key.action === "caps")
              ? key.label
              : (this.isShifted || this.isCaps)
              ? key.label.toUpperCase()
              : key.label.toLowerCase(),
        }))
      );
      return {
        letters: newLetters,
        symbols: this.keyLayout.symbols,
      };
    },
  },

  mounted() {
    this.updateKeysCase();
  },
  methods: {
    toggleShift() {
      this.isShifted = !this.isShifted;
      this.updateKeysCase();
    },
    updateKeysCase() {
      this.keyLayout.letters.forEach((row) => {
        row.forEach((key) => {
          if (key.label && !key.action) {
            key.label = (this.isShifted || this.isCaps)
              ? key.label.toUpperCase()
              : key.label.toLowerCase();
          }
        });
      });
    },
    handleClick(key) {
      if (key.action === "remove") {
        this.$emit("removeLastChar");
      } else if (key.action === "toggle") {
        this.layout = this.layout === "letters" ? "symbols" : "letters";
      } else if (key.action === "shift") {
        this.toggleShift();
      } else if (key.action === "space") {
        this.$emit("addToInput", " ");
      } else if (key.action === "caps") {
        this.isCaps = !this.isCaps;
      } else if (key.action === "tab") {
        this.$emit("addToInput", "    ");
      } else {
        this.$emit("addToInput", key.label);

        if (!this.isCaps && this.isShifted) {
          this.isShifted = false;
        }
      }
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped>
.row {
  display: flex;
  gap: 0.5vw;
  width: 100%;
  margin-bottom: 0.5vw;
}
.item {
  background: rgba(217, 217, 217, 0.5);
  height: 3.75vw;
  width: 3.75vw;
  border-radius: 1vw;
  font-family: "Roboto Bold";
  font-size: 1.75vw;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px 0 rgba(83, 83, 83, 0.25);
  transition: transform 0.2s ease;
}
.item:hover,
.item:active {
  background: rgba(217, 217, 217, 0.8);
  cursor: pointer;
  transform: scale(1.1);
  animation: hoverEffect 1.5s ease-out;
}

@keyframes hoverEffect {
  0% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.item-small {
  font-size: 1.5vw;
}

.btn {
  background-color: #68aef9;
  color: #fff;
  font-family: "Roboto Bold";
  font-size: 1.25vw;
  letter-spacing: -0.075vw;
  padding: 0.5vw 1vw;
  border-radius: 3vw;
  margin-left: 1vw;
  width: 10vw;
  height: 1.5vw;
  border: none;
  margin: auto;
  cursor: pointer;
  text-align: center;
  line-height: 1.5vw;
  transition: transform 0.2s;
  margin-bottom: 0.5vw;
}
.btn:hover {
  transform: scale(1.05);
}
.btn:focus {
  outline: none;
}

.keyboard .four-col {
  width: 8.5vw !important;
}

.keyboard .double-col {
  width: 6vw !important;
}

.small-keyboard .four-col {
  width: 7.5vw !important;
}
</style>
